var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail create" }, [
    _c("div", { staticClass: "screen" }, [
      _c(
        "div",
        { staticClass: "banner" },
        [
          _c("mt-field", {
            attrs: { readonly: "", label: "表单编号" },
            model: {
              value: _vm.detail.businessKey,
              callback: function($$v) {
                _vm.$set(_vm.detail, "businessKey", $$v)
              },
              expression: "detail.businessKey"
            }
          })
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "center" },
      [
        _c("applicant-info", {
          attrs: {
            editable: false,
            costName: _vm.detail.costCenterName,
            lineName: _vm.detail.businessLineName,
            applicant: _vm.detail.applicantName,
            createUserName: _vm.detail.submiterName,
            createDate: _vm.detail.applicationDateStr
          }
        }),
        _vm.detail.currentRole == 2 || _vm.detail.currentRole == 3
          ? _c(
              "div",
              { staticClass: "a_infor", class: { open: _vm.isOpen } },
              [
                _c(
                  "p",
                  {
                    on: {
                      click: function($event) {
                        _vm.isOpen = !_vm.isOpen
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.title))]
                ),
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _c("mt-radio", {
                      attrs: { title: "协议类型：", options: _vm.TypeOptions },
                      model: {
                        value: _vm.request.protocolType,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "protocolType", $$v)
                        },
                        expression: "request.protocolType"
                      }
                    }),
                    _c("mt-radio", {
                      attrs: {
                        title: "签订类型：",
                        options: _vm.SignedOptions
                      },
                      model: {
                        value: _vm.request.signType,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "signType", $$v)
                        },
                        expression: "request.signType"
                      }
                    }),
                    _c("mt-field", {
                      attrs: {
                        readonly: "",
                        label: "合同开始日期",
                        placeholder: "请选择开始日期"
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.ShowPicker(1)
                        }
                      },
                      model: {
                        value: _vm.request.startDate,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "startDate", $$v)
                        },
                        expression: "request.startDate"
                      }
                    }),
                    _c("mt-field", {
                      attrs: {
                        readonly: "",
                        label: "合同结束日期",
                        placeholder: "请选择结束日期"
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.ShowPicker(2)
                        }
                      },
                      model: {
                        value: _vm.request.endDate,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "endDate", $$v)
                        },
                        expression: "request.endDate"
                      }
                    }),
                    _c("p", [_vm._v("合同信息（项目名称）")]),
                    _c("mt-field", {
                      attrs: {
                        placeholder: "合同信息（项目名称），最多50个字",
                        attr: { maxlength: 50 },
                        type: "textarea",
                        rows: "1"
                      },
                      model: {
                        value: _vm.request.info,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "info", $$v)
                        },
                        expression: "request.info"
                      }
                    }),
                    _c("p", [_vm._v("合同内容")]),
                    _c("mt-field", {
                      attrs: {
                        placeholder:
                          "描述合同的内容及签订的原因或变化的原因，最多300个字",
                        attr: { maxlength: 300 },
                        type: "textarea",
                        rows: "3"
                      },
                      model: {
                        value: _vm.request.contractContent,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "contractContent", $$v)
                        },
                        expression: "request.contractContent"
                      }
                    }),
                    _vm.request.signType != "10"
                      ? _c("mt-radio", {
                          attrs: {
                            title: "当前合同金额类型：",
                            options: _vm.amountType
                          },
                          model: {
                            value: _vm.request.curContractType,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "curContractType", $$v)
                            },
                            expression: "request.curContractType"
                          }
                        })
                      : _vm._e(),
                    _vm.request.signType != "10" &&
                    _vm.request.curContractType == 10
                      ? _c(
                          "mt-field",
                          {
                            attrs: {
                              label: "当前合同金额",
                              placeholder: "请输入当前合同金额",
                              type: "number"
                            },
                            model: {
                              value: _vm.request.currentAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.request, "currentAmount", $$v)
                              },
                              expression: "request.currentAmount"
                            }
                          },
                          [_vm._v("元")]
                        )
                      : _vm._e(),
                    _vm.request.signType != "10" &&
                    _vm.request.curContractType == 20
                      ? _c("mt-field", {
                          attrs: {
                            label: "当前合同金额",
                            placeholder: "请输入当前合同金额"
                          },
                          model: {
                            value: _vm.request.currentAmount,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "currentAmount", $$v)
                            },
                            expression: "request.currentAmount"
                          }
                        })
                      : _vm._e(),
                    _c("mt-radio", {
                      attrs: {
                        title: "新合同金额类型：",
                        options: _vm.amountType
                      },
                      model: {
                        value: _vm.request.newContractType,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "newContractType", $$v)
                        },
                        expression: "request.newContractType"
                      }
                    }),
                    _vm.request.newContractType == 10
                      ? _c(
                          "mt-field",
                          {
                            attrs: {
                              label: "新合同金额",
                              placeholder: "请输入新合同金额",
                              type: "number"
                            },
                            model: {
                              value: _vm.request.newAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.request, "newAmount", $$v)
                              },
                              expression: "request.newAmount"
                            }
                          },
                          [_vm._v("元")]
                        )
                      : _vm._e(),
                    _vm.request.newContractType == 20
                      ? _c("mt-field", {
                          attrs: {
                            label: "新合同金额",
                            placeholder: "请输入新合同金额"
                          },
                          model: {
                            value: _vm.request.newAmount,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "newAmount", $$v)
                            },
                            expression: "request.newAmount"
                          }
                        })
                      : _vm._e(),
                    _vm.request.signType != "10"
                      ? _c("mt-radio", {
                          attrs: {
                            title: "当前付款周期",
                            options: _vm.PaymentOptions
                          },
                          model: {
                            value: _vm.request.currentPaymentTerms,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "currentPaymentTerms", $$v)
                            },
                            expression: "request.currentPaymentTerms"
                          }
                        })
                      : _vm._e(),
                    _vm.request.signType != "10" &&
                    _vm.request.currentPaymentTerms == "30"
                      ? _c("mt-field", {
                          attrs: {
                            placeholder: "请输入当前付款周期",
                            attr: { maxlength: 20 }
                          },
                          model: {
                            value: _vm.request.currentPaymentTermsOther,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.request,
                                "currentPaymentTermsOther",
                                $$v
                              )
                            },
                            expression: "request.currentPaymentTermsOther"
                          }
                        })
                      : _vm._e(),
                    _c("mt-radio", {
                      attrs: {
                        title: "新付款周期",
                        options: _vm.PaymentOptions
                      },
                      model: {
                        value: _vm.request.newPaymentTerms,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "newPaymentTerms", $$v)
                        },
                        expression: "request.newPaymentTerms"
                      }
                    }),
                    _vm.request.newPaymentTerms == "30"
                      ? _c("mt-field", {
                          attrs: {
                            placeholder: "请输入新付款周期",
                            attr: { maxlength: 20 }
                          },
                          model: {
                            value: _vm.request.newPaymentTermsOther,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "newPaymentTermsOther", $$v)
                            },
                            expression: "request.newPaymentTermsOther"
                          }
                        })
                      : _vm._e(),
                    _vm.request.signType == "10"
                      ? _c("mt-radio", {
                          staticStyle: { "justify-content": "center" },
                          attrs: {
                            title: "是否添加到SCM系统(仅限新合同填写)",
                            options: _vm.AddSCMOptions
                          },
                          model: {
                            value: _vm.request.addSCMStr,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "addSCMStr", $$v)
                            },
                            expression: "request.addSCMStr"
                          }
                        })
                      : _vm._e(),
                    _vm.currentApproverStr
                      ? _c("mt-field", {
                          attrs: { readonly: "", label: "当前处理人" },
                          model: {
                            value: _vm.currentApproverStr,
                            callback: function($$v) {
                              _vm.currentApproverStr = $$v
                            },
                            expression: "currentApproverStr"
                          }
                        })
                      : _vm._e(),
                    _c("p", [_vm._v("备注")]),
                    _c("mt-field", {
                      staticStyle: { "padding-bottom": "20px" },
                      attrs: {
                        placeholder: "请输入备注信息",
                        attr: { maxlength: 300 },
                        type: "textarea",
                        rows: "3"
                      },
                      model: {
                        value: _vm.request.remark,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "remark", $$v)
                        },
                        expression: "request.remark"
                      }
                    })
                  ],
                  1
                ),
                _c("mt-datetime-picker", {
                  ref: "picker1",
                  attrs: {
                    type: "date",
                    startDate: new Date("2010-01-01"),
                    endDate: new Date("2077-12-31"),
                    "year-format": "{value}年",
                    "month-format": "{value}月",
                    "date-format": "{value}日"
                  },
                  on: { confirm: _vm.handleConfirm1 },
                  nativeOn: {
                    touchmove: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                    }
                  },
                  model: {
                    value: _vm.defaultStartDate,
                    callback: function($$v) {
                      _vm.defaultStartDate = $$v
                    },
                    expression: "defaultStartDate"
                  }
                }),
                _c("mt-datetime-picker", {
                  ref: "picker2",
                  attrs: {
                    type: "date",
                    startDate: _vm.defaultStartDate,
                    endDate: new Date("2077-12-31"),
                    "year-format": "{value}年",
                    "month-format": "{value}月",
                    "date-format": "{value}日"
                  },
                  on: { confirm: _vm.handleConfirm2 },
                  nativeOn: {
                    touchmove: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c("attach-upload", {
          attrs: {
            canUpload: true,
            deletable: true,
            maxLength: 10,
            value: _vm.request.attachmentList,
            contractList: _vm.detail.contractList,
            attachFileList: _vm.detail.attachFileList,
            legalList: _vm.detail.legalList,
            coeList: _vm.detail.coeList,
            contractType: _vm.request.contractType
          }
        }),
        _c(
          "div",
          { staticClass: "a_infor", class: { open: _vm.approveOpen } },
          [
            _c(
              "p",
              {
                staticClass: "red",
                on: {
                  click: function($event) {
                    _vm.approveOpen = !_vm.approveOpen
                  }
                }
              },
              [_vm._v("备注")]
            ),
            _c(
              "div",
              {
                staticClass: "box",
                staticStyle: { "padding-bottom": "20px", "margin-top": "10px" }
              },
              [
                _c("mt-field", {
                  attrs: {
                    placeholder: "请输入...",
                    attr: { maxlength: 200 },
                    type: "textarea",
                    rows: "3"
                  },
                  model: {
                    value: _vm.approveRequest.approveRemark,
                    callback: function($$v) {
                      _vm.$set(_vm.approveRequest, "approveRemark", $$v)
                    },
                    expression: "approveRequest.approveRemark"
                  }
                }),
                _c("ul", { staticClass: "buttons" }, [
                  _c(
                    "li",
                    [
                      _c(
                        "mt-button",
                        {
                          attrs: { type: "default" },
                          on: {
                            click: function($event) {
                              return _vm.ConfirmEdit()
                            }
                          }
                        },
                        [_vm._v("更新")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "mt-button",
                        {
                          attrs: { type: "default" },
                          on: {
                            click: function($event) {
                              return _vm.GoBack()
                            }
                          }
                        },
                        [_vm._v("返回")]
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "clear" })
              ],
              1
            )
          ]
        ),
        _c("operation-log", {
          attrs: { list: _vm.detail.contractOperationLog }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }